/* enemy-product.js — galería, swatches, tallas, acordeones, modal */
(function () {
  'use strict';

  /* ── Thumbnail gallery ──────────────────────────────────────── */
  function initGallery() {
    const mainImg = document.querySelector('.ec-product__main-image img');
    const thumbs = document.querySelectorAll('.ec-product__thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach((thumb, i) => {
      if (i === 0) thumb.classList.add('is-active');
      thumb.addEventListener('click', () => {
        const src = thumb.querySelector('img')?.src;
        if (!src) return;
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 150);
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    /* Mobile: swipe between images */
    let startX = 0;
    let currentIndex = 0;
    mainImg.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    mainImg.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 50) return;
      if (diff > 0) currentIndex = Math.min(currentIndex + 1, thumbs.length - 1);
      else currentIndex = Math.max(currentIndex - 1, 0);
      thumbs[currentIndex]?.click();
    });
  }

  /* ── Size selector ──────────────────────────────────────────── */
  function initSizeSelector() {
    document.querySelectorAll('.ec-size').forEach(btn => {
      if (btn.classList.contains('is-unavailable')) return;
      btn.addEventListener('click', () => {
        document.querySelectorAll('.ec-size').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput && btn.dataset.variantId) {
          variantInput.value = btn.dataset.variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  /* ── Color swatch ───────────────────────────────────────────── */
  function initSwatches() {
    document.querySelectorAll('.ec-swatch').forEach(swatch => {
      swatch.addEventListener('click', () => {
        document.querySelectorAll('.ec-swatch').forEach(s => s.classList.remove('is-selected'));
        swatch.classList.add('is-selected');

        const colorLabel = document.querySelector('.ec-swatch-label span');
        if (colorLabel) colorLabel.textContent = swatch.dataset.colorName || '';
      });
    });
  }

  /* ── Accordions ─────────────────────────────────────────────── */
  function initAccordions() {
    document.querySelectorAll('.ec-accordion__trigger').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const accordion = trigger.closest('.ec-accordion');
        const isOpen = accordion.classList.contains('is-open');
        document.querySelectorAll('.ec-accordion').forEach(a => a.classList.remove('is-open'));
        if (!isOpen) accordion.classList.add('is-open');
      });
    });
  }

  /* ── Size guide modal ───────────────────────────────────────── */
  function initSizeGuide() {
    const overlay = document.querySelector('.ec-modal-overlay');
    const close = document.querySelector('.ec-modal__close');
    if (!overlay) return;

    function openModal() {
      overlay.classList.add('is-open');
      document.body.classList.add('ec-no-scroll');
    }
    function closeModal() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('ec-no-scroll');
    }

    document.querySelectorAll('.ec-size-guide-link').forEach(btn => {
      btn.addEventListener('click', openModal);
    });

    close?.addEventListener('click', closeModal);
    overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });
  }

  /* ── Sticky add to cart (mobile) ────────────────────────────── */
  function initStickyCart() {
    const stickyBtn = document.querySelector('.ec-sticky-add-to-cart');
    const mainBtn = document.querySelector('.ec-product__cta .ec-btn--primary');
    if (!stickyBtn || !mainBtn) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        stickyBtn.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    observer.observe(mainBtn);

    stickyBtn.addEventListener('click', () => {
      mainBtn.click();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initGallery();
    initSizeSelector();
    initSwatches();
    initAccordions();
    initSizeGuide();
    initStickyCart();
  });
})();
